export const $ = (s, root = document) => root.querySelector(s);
export const $$ = (s, root = document) => [...root.querySelectorAll(s)];
// Layar sentuh (HP/tablet): jangan fokus otomatis ke kotak isian, karena
// keyboard di layar akan langsung muncul dan menutupi soal.
export const layarSentuh = () => !!(window.matchMedia && matchMedia('(hover: none) and (pointer: coarse)').matches);
export const prefersReducedMotion = () => !!(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches);
